import { EmptyState as NovaEmptyState, EmptyStateProps as NovaEmptyStateProps } from '@fme-nova/components'
import React, { ReactNode } from 'react'

import { createComponentWrapperWithRef, styled } from '../../theme'
import { Typography } from '../Typography'

const ImageWrapper = styled('div')`
  max-width: 320px;
  max-height: 240px;
`
const StyledImg = styled('img')`
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
`

function MuiEmptyState(props: NovaEmptyStateProps) {
  return (
    <>
      {props.illustration && (
        <ImageWrapper>
          {typeof props.illustration === 'string' && <StyledImg src={props.illustration as string} />}
          {typeof props.illustration !== 'string' && (props.illustration as ReactNode)}
        </ImageWrapper>
      )}
      {(props.title || props.body) && (
        <Typography variant="body1">
          {props.title}
          {props.body && (
            <>
              <br />
              {props.body}
            </>
          )}
        </Typography>
      )}
    </>
  )
}

export const EmptyState = createComponentWrapperWithRef<NovaEmptyStateProps>(
  {
    mui: MuiEmptyState,
    nova: NovaEmptyState,
  },
  'EmptyState',
)
